<template>
    <AppChartWrapper
            :imageName="name"
            style="height: 100%"
    >
        <h4 class="subheading font-weight-regular text-xs-left section-title--color" slot="title">
            <span>{{ name+' - ' | unescapeString }}</span>
            <span class="font-weight-bold description--color" v-if="summaryDataReady">{{ categoriesCount | formatNumber }}</span>
        </h4>
        <v-layout class="pt-3" row slot="chart" v-if="summaryDataReady" wrap>
            <v-flex class="doughnut-chart-wrapper" pt-0 xs12>
                <DoughnutChart
                        :chartData="totalCategoriesDoughnutChartData"
                        :height="230"
                        :options="totalCategoriesDoughnutChartOptions"
                        :width="200"
                />
            </v-flex>
            <v-flex xs12>
                <v-layout justify-space-around row text-xs-center>
                    <v-flex :class="{'category__count--border': index < categoryRangeOrdered.length-1 }" :key="index"
                            v-for="(category, index) in categoryRangeOrdered" xs3>
                        <TotalCategoriesCount :category="category" :categoryColor="categoryColor"
                                              :isReaction="isReaction"/>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </AppChartWrapper>
</template>

<script>
	import DoughnutChart from "@/components/DoughnutChart";
	import TotalCategoriesCount from "@/components/TotalCategoriesCount";
	import {thousandSeperator} from "@/utils";
	import AppChartWrapper from "./AppChartWrapper";
	export default {
		data() {
			return {
				totalCategoriesDoughnutChartOptions: {
					responsive: true,
					maintainAspectRatio: false,
					legend: {
						labels: {
							boxWidth: 22,
							fontSize: 11
						}
					},
					layout: {
						padding: 10
					},
					tooltips: {
						callbacks: {
							label: (tooltipItem, data) => {
								let dataset = data.datasets[tooltipItem.datasetIndex];
								let meta = dataset._meta[Object.keys(dataset._meta)[0]];
								let total = meta.total;
								let currentValue = dataset.data[tooltipItem.index];
								let percentage = parseFloat(
									((currentValue / total) * 100).toFixed(1)
								);
								// return percentage + '%'
								return thousandSeperator(currentValue) + " (" + percentage + "%)";
							},
							title: (tooltipItem, data) => {
								return data.labels[tooltipItem[0].index];
							}
						}
					},
					cutoutPercentage: 70
				}
			};
		},

		props: {
			categoryRangeOrdered: {
				type: Array,
				required: true,
                default(){
					return []
                }
			},

			categoryColor: {
				type: Object,
				required: true
			},

            summaryDataReady:{
				type: Boolean,
                required: true,
            },

            name:{
				type: String,
                default: "Title",
                required: true
            },

            isReaction: {
				type: Boolean,
                required: true
            }
		},

		computed: {
			categoriesCount() {
				return this.categoryRangeOrdered.reduce((acc, cur) => acc + cur.count, 0) || 0;
			},

			totalCategoriesDoughnutChartData() {
				if(this.categoryRangeOrdered.every(category => category.count === 0 )) return {};
				const labels = [];
				const data = [];
				const backgroundColor = [];
				this.categoryRangeOrdered.map(c => {
					labels.push(c.value);
					data.push(c.count);
					backgroundColor.push(this.categoryColor[c.value]);
				});
				return {
					labels,
					datasets: [
						{
							data,
							backgroundColor
						}
					]
				};
			},
		},

		components: {
			TotalCategoriesCount,
			DoughnutChart,
            AppChartWrapper
		},
	};
</script>

<style>
    .doughnut-chart-wrapper {
        margin-top: -14px;
        position: relative;
        width: 22vw;
    }

    .category__count--border {
        border-right-color: #efefef;
        border-right-style: solid;
        border-right-width: 1px;
    }
</style>
